/**
 * Registrazione del service worker Sanità (/sanitario-sw.js, scope /sanitario).
 * Solo nel build di produzione, oppure con REACT_APP_SANITARIO_SW=1.
 */
export const SANITARIO_SW_URL = "/sanitario-sw.js";
export const SANITARIO_SW_SCOPE = "/sanitario";
export const SANITARIO_UPDATE_EVENT = "sanitario-sw-update";

let waitingWorker = null;
let reloading = false;
let updateRequested = false;

export function sanitarioSwEnabled(env = process.env) {
  return env.NODE_ENV === "production" || env.REACT_APP_SANITARIO_SW === "1";
}

function announce(worker) {
  waitingWorker = worker;
  window.dispatchEvent(new CustomEvent(SANITARIO_UPDATE_EVENT, { detail: { waiting: true } }));
}

export async function registerSanitarioServiceWorker({ nav = typeof navigator !== "undefined" ? navigator : null, env = process.env } = {}) {
  if (!nav || !("serviceWorker" in nav) || !sanitarioSwEnabled(env)) return null;
  try {
    const reg = await nav.serviceWorker.register(SANITARIO_SW_URL, { scope: SANITARIO_SW_SCOPE });
    if (reg.waiting && nav.serviceWorker.controller) announce(reg.waiting);
    reg.addEventListener("updatefound", () => {
      const w = reg.installing;
      if (!w) return;
      w.addEventListener("statechange", () => {
        if (w.state === "installed" && nav.serviceWorker.controller) announce(w);
      });
    });
    nav.serviceWorker.addEventListener("controllerchange", () => {
      if (reloading || !updateRequested) return;
      reloading = true;
      window.location.reload();
    });
    const check = () => reg.update().catch(() => {});
    window.addEventListener("focus", check);
    return reg;
  } catch {
    return null;
  }
}

export function hasSanitarioUpdate() {
  return !!waitingWorker;
}

export function applySanitarioUpdate() {
  if (!waitingWorker) return false;
  updateRequested = true;
  waitingWorker.postMessage({ type: "SKIP_WAITING" });
  return true;
}

export function __resetSanitarioSw() {
  waitingWorker = null;
  reloading = false;
  updateRequested = false;
}
